import { z } from 'zod';

export const loginValidator = z.object({
  email: z.string(),
  password: z.string(),
  isSeller: z.string(),
});

export const logoutValidator = z.object({
  sessionId: z.string(),
});

export type LoginInput = z.infer<typeof loginValidator>;
export type LogoutInput = z.infer<typeof logoutValidator>;
